/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";

type CommentModifierProps = {
  setIsEditMode: React.Dispatch<React.SetStateAction<boolean>>;
  setIsRemoveMode: React.Dispatch<React.SetStateAction<boolean>>;
  author: boolean;
};

function CommentModifier({
  setIsEditMode,
  setIsRemoveMode,
  author,
}: CommentModifierProps) {
  return (
    <>
      <FlexContainer>
        <Button
          mb="1rem"
          disabled={!author}
          severity="low"
          icon="edit"
          size="md"
          onClick={() => setIsEditMode(true)}
        >
          Edit
        </Button>
        <Button
          mb="1rem"
          ml="0.5rem"
          severity="low"
          icon="trash"
          size="md"
          onClick={() => setIsRemoveMode(true)}
        >
          Delete
        </Button>
      </FlexContainer>
    </>
  );
}

export { CommentModifier };
